<template>
  <div :style="containerStyles">{{ time_readable }}</div>
</template>

<script>
import { format, parse } from 'date-fns'
import * as TimeFormats from '@/constants/TimeFormats'

export default {
  name: 'AdminCellTimestampReadable',
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    width: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {}
  },
  computed: {
    time_readable() {
      return format(
        parse(this.value, TimeFormats.dateAndTimeSlashes12hr, new Date()),
        TimeFormats.dateAndTimeSlashes12hr
      )
    }, // time_readable
    containerStyles() {
      let maxWidth =
        typeof this.width === 'number' ? `${this.width}px` : this.width
      return {
        maxWidth,
      }
    }, // containerStyles
  },
}
</script>
